enum Format {
  DATE_TIME = 'DD/MM/YYYY',
  DATE_TIMESTAMP = 'HH:mm DD/MM/YYYY',
  TIME = 'HH:mm',
}
export default Format;
